import {
  useMutateBatchApproveTravels,
  type BatchApproveTravelItem,
} from '../../models'

// Toasts live in the composing Feature Set (`TravelApprovalListView`) —
// rejections propagate to the caller (ADR-10 via getMessageFromError there).
export const useBatchApproveTravelsPresenter = () => {
  const { batchApprove, isApproving } = useMutateBatchApproveTravels()

  const batchApproveCommand = async (
    items: BatchApproveTravelItem[]
  ): Promise<void> => {
    // BHV-033: double-submit guard
    if (isApproving) return

    await batchApprove(items)
  }

  return {
    commands: {
      batchApprove: batchApproveCommand,
    },
    states: {
      isSubmitting: isApproving,
    },
  }
}
